<template>
	<el-dialog
		class="join-pop"
		title="选择教师"
		size="small"
		:visible.sync="showJoinPop"
		width="600px"
		center
		:before-close="beforeClose"
    :modal="modal"
	>
		<div class="transfer-box">
			<div class="transfer-search">
				<div style="margin-bottom: 10px;">
					<span>校区：</span>
					<el-select
						size="small"
						class="select-school"
						clearable
						@change="schoolChange"
						v-model="teacherSearchForm.schoolCode"
						placeholder="请选择"
					>
						<el-option label="全部" value></el-option>
						<el-option
							v-for="(i,index) in schoolList"
							:key="index"
							:label="i.schoolName"
							:value="i.schoolCode"
						></el-option>
					</el-select>
					<span>年级：</span>
					<el-select
						size="small"
						@change="gradeChange"
						v-model="teacherSearchForm.grade"
						clearable
						placeholder="请选择"
					>
						<el-option v-for="i in gradeOptions" :key="i.id" :label="i.gradeName" :value="i.grade"></el-option>
					</el-select>
				</div>
				<div style="margin-bottom: 10px;">
					<span>班级：</span>
					<el-select
						@change="submit"
						size="small"
						class="select-school"
						v-model="teacherSearchForm.classCode"
						clearable
						placeholder="请选择"
					>
						<el-option v-for="i in classOptions" :key="i.id" :label="i.className" :value="i.classCode"></el-option>
					</el-select>
					<span>学科：</span>
					<el-select
						@change="submit"
						size="small"
						v-model="teacherSearchForm.disciplineCode"
						clearable
						placeholder="请选择"
					>
						<el-option
							v-for="i in disciplineOptions"
							:key="i.id"
							:label="i.disciplineName"
							:value="i.disciplineCode"
						></el-option>
					</el-select>
				</div>
				<div>
					<span>关键字：</span>
					<el-input
						@change="submit"
						size="small"
						style="width: 300px;"
						v-model="teacherSearchForm.keyword"
						clearable
						placeholder="请输入"
					>
						<el-button type="primary" slot="append" class="search-btn" size="small" @click="submit">搜索</el-button>
					</el-input>
				</div>
			</div>
			<div class="transfer-content">
				<el-row type="flex" align="middle" justify="center">
					<el-col :span="11">
						<h3 style="padding-left: 10px;">
							<el-checkbox
								size="small"
								:indeterminate="isIndeterminate"
								v-model="checkAll"
								@change="handleCheckAllChange"
							>教师列表</el-checkbox>
						</h3>
						<el-checkbox-group size="small" v-model="checkedUserIds" @change="handleCheckedChange">
							<ul v-loading="loading">
								<li v-for="i in usersData" :key="i.userId">
									<el-checkbox :label="i.userId"><span>{{ i.userName }}</span> <span class="tsch">{{i.schoolName}}</span> </el-checkbox>
								</li>
							</ul>
						</el-checkbox-group>
					</el-col>
					<el-col :span="2" align="middle"></el-col>
					<el-col :span="11">
						<h3>
							教师列表
							<el-button plain class="allRemove el-icon-close" size="small" @click="removeAllUser">全部移除</el-button>
						</h3>
						<ul>
							<li v-for="i in checkedUsers" :key="i.userId">
								<el-tag closable type @close="removeUser(i.userId)">{{ i.userName }}</el-tag>
							</li>
						</ul>
					</el-col>
				</el-row>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="cancel">取 消</el-button>
			<el-button type="primary" @click="addUserOk">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
export default {
	props: {
    showJoinPop: "",
     modal: {
      type: Boolean,
      default: true,
    },
	},
	computed: {
		...mapState(["userInfo", "schoolList"]),
		checkedUserIds: {
			get() {
				return this.checkedUsers.map(u => u.userId);
			},
			set(ids) {
				// 根据选中的id更新checkedUsers
				const allUsers = [...this.checkedUsers, ...this.usersData];
				const userMap = new Map();
				allUsers.forEach(u => {
					if (!userMap.has(u.userId)) {
						userMap.set(u.userId, u);
					}
				});
				this.checkedUsers = ids.map(id => userMap.get(id)).filter(u => u);
			}
		}
	},
	data() {
		return {
			gradeOptions: [],
			classOptions: [],
			disciplineOptions: [],
			teacherSearchForm: {
				schoolCode: "",
				grade: "",
				classCode: "",
				disciplineCode: "",
				keyword: ""
			},
			loading: false,
			checkAll: false,
			isIndeterminate: true,
			usersData: [],
			checkedUsers: []
		};
	},
	created() {
		this.submit();
	},
	methods: {
		async schoolChange(val) {
			this.teacherSearchForm.grade = "";
			this.teacherSearchForm.classCode = "";
			this.teacherSearchForm.disciplineCode = "";
			this.gradeOptions = await postData("/school/getGradeList", {
				schoolCode: val
			});
			this.submit();
			this.getDiscipline();
		},
		async gradeChange(val) {
			this.teacherSearchForm.classCode = "";
			this.classOptions = await getData("/school/getClassInfoList", {
				schoolCode: this.teacherSearchForm.schoolCode,
				grade: val,
				pageSize: -1,
				pageNum: 1
			});
			this.submit();
		},
		async getDiscipline() {
			this.disciplineOptions = await postData(
				"/discipline/getDisciplinelList",
				{
					schoolCode: this.teacherSearchForm.schoolCode
				}
			);
		},
		submit() {
			this.loading = true;
			postJson(
				"/user/getTeacherInfoList",
				{
					...this.teacherSearchForm,
					schoolCodes: this.teacherSearchForm.schoolCode ? [] : this.schoolList.map(m => m.schoolCode)
				}
			).then(res => {
				if (res.records.length > 0) {
					let records = res.records;
					this.usersData = records.map(m=>{
						if(m.teacherSchoolList.some(f=>f.status==1)){
							m.schoolName=m.teacherSchoolList.find(f=>f.status==1).schoolName
						}
						return m
					})
				} else {
					this.usersData = []
				}
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});

		},
		handleCheckAllChange(val) {
			if (val) {
				// 全选时，合并当前页面的用户到已选用户中
				const existingIds = new Set(this.checkedUsers.map(u => u.userId));
				const newUsers = this.usersData.filter(u => !existingIds.has(u.userId));
				this.checkedUsers = [...this.checkedUsers, ...newUsers];
			} else {
				// 取消全选时，移除当前页面的用户
				const currentIds = new Set(this.usersData.map(u => u.userId));
				this.checkedUsers = this.checkedUsers.filter(u => !currentIds.has(u.userId));
			}
			this.isIndeterminate = false;
		},
		handleCheckedChange(value) {
			// 计算当前页面中被选中的用户数量
			const currentUserIds = this.usersData.map(u => u.userId);
			const checkedCountInCurrentPage = value.filter(id => currentUserIds.includes(id)).length;

			this.checkAll = checkedCountInCurrentPage === this.usersData.length;
			this.isIndeterminate =
				checkedCountInCurrentPage > 0 && checkedCountInCurrentPage < this.usersData.length;

			console.log(this.checkedUsers, 'this.checkedUsers');
		},
		removeUser(userId) {
			this.checkedUsers = this.checkedUsers.filter(i => i.userId != userId);
		},
		removeAllUser() {
			this.checkedUsers = [];
		},
		addUserOk() {
			if (this.checkedUsers.length === 0) {
				this.$message.error("请先选择教师！");
			} else {
				this.$emit(
					"joinUsersChange",
					this.checkedUsers.map(i => {
						return {
							userId: i.userId,
							userName: i.userName,
							schoolCode: i.schoolCode
						};
					})
				);
				this.$emit("close");
			}
		},
		cancel() {
			this.$emit("close");
		},
		beforeClose() {
			this.$emit("close");
		}
	},
	watch: {
		// joinUsers(val, oldVal) {
		// 	this.$emit("joinUserChange", val);
		// }
	}
};
</script>

<style lang="less" scoped>
.tsch{
	margin-left: 10px;
	font-size: 12px;
	color: gray;

}
.join-pop {
	/deep/.el-dialog--center {
		border-radius: 15px;
	}
	/deep/.el-dialog--center .el-dialog__body {
		padding: 0px 15px;
	}
	.transfer-box {
		padding-bottom: 10px;
		border: 1px solid rgb(231, 227, 227);
		border-radius: 5px;
		.transfer-search {
			padding: 10px;
			padding-right: 15px;
			.select-school {
				margin-right: 20px;
			}
			.search-btn {
				margin-right: 22px;
			}
		}
		/deep/.transfer-content {
			margin-top: 3px;
			padding: 0px 10px;
			.el-row {
				border: 1px solid #eee;
				.el-col {
					border: 1px solid rgb(243, 241, 241);
					h3 {
						padding-left: 20px;
						font-size: 15px;
						background-color: #eee;
						height: 32px;
						line-height: 32px;
					}
					ul {
						// border: 1px solid rgb(206, 36, 36);
						padding: 5px;
						padding-left: 10px;
						overflow-y: auto;
						height: 345px;
						margin: 0px;
						li {
							// border: 1px solid rgb(55, 40, 192);
							padding: 0px;
							height: 30px;
							.el-tag {
								height: 25px;
								line-height: 25px;
								padding: 0px 8px;
								border: 1px solid #eee;
							}
						}
					}
					.allRemove {
						padding: 4px;
						margin-left: 20px;
					}
				}
			}
			// .btn-col{
			// 	height: 300px;
			// }
		}
	}
}
</style>
